<template lang="pug">
    span(class="_dots", role="progressbar")
        svg(v-for="i in 3", viewBox="0 0 2 2")
            circle(cx="1", cy="1", r="1")
</template>

<script>
    /**
     * Three animated dots.
     */
    export default {
        name: 'ib-progress-dots'
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    @keyframes _dots {
        0% {
            transform: scale(.5);
            opacity: .2;
        } 20% {
            transform: scale(1);
            opacity: 1;
        } 100% {
            transform: scale(.5);
            opacity: .2;
        }
    }

    ._dots {
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        width: 2.25em;
        height: 1.25em;

        > svg {
            width: auto;
            height: 50%;
            animation: _dots 1.4s linear 0s infinite normal both;
            transform-origin: center;
        }
        > :nth-child(2) {
            animation-delay: .2s;
        }
        > :nth-child(3) {
            animation-delay: .4s;
        }
    }
</style>

<ib-example id="basic" name="Basic">
    <template lang="pug">
        ib-progress-dots
    </template>
</ib-example>
